module.exports = __webpack_public_path__ + "img/anli3@2X.bd4d9c8e.png";